module.exports = __webpack_public_path__ + "img/lottery_mobi_enter.1f1aeca2.png";